<script lang="ts" setup>
import { Badge } from '@forgd/ui-kit/badge'

const props = defineProps<{
  dark?: boolean
  collapsed?: boolean
  appName?: string
}>()

const runtimeConfig = useRuntimeConfig()

const src = computed(() => {
  return props.dark ? '/app/logo-dark.svg' : '/app/logo-light.svg'
})

const isLiquidity = computed(() => runtimeConfig.public.portal === 'liquidity')

const badgeClasses = computed(() => {
  if (isLiquidity.value && !props.dark) {
    return 'w-full justify-center border-none bg-primary text-white'
  }
  return 'w-full justify-center border-primary-500 bg-brand-300/10 text-primary-100'
})
</script>

<template>
  <div v-if="!collapsed" data-ui="AppLogo" class="flex flex-col items-center gap-2.5 mx-auto">
    <img
      :src="src"
      alt="Forgd Logo"
      width="140"
      height="18"
    >
    <Badge v-if="appName" size="sm" :class="badgeClasses">
      <span class="uppercase tracking-[2px]">{{ appName }}</span>
    </Badge>
  </div>
  <i
    v-else
    data-ui="AppLogo"
    role="img"
    aria-label="Forgd Logo"
    class="i-forgd-logo size-6 shrink-0"
    :class="{ 'text-white': !dark }"
  />
</template>
